export default "__VITE_ASSET__84da953c__"